// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '옵투us제약',
  targetSheetName: 'Table 1',
  headerRowIndex: 2,
  headerRowCount: 1,
  dataStartRowIndex: 3,
  columnMapping: {
    drugCode: '보험코드',
    drugName: '제품명',
    price: '포장약가',
    commissionRate: '수수료율',
    commissionNote: '비고',
  },
  requiredHeaders: [
    '구분',
    '보험코드',
    '제품명',
    '성분/함량',
    '포장단위',
    '단위약가',
    '포장약가',
    '수수료율',
    '비고',
  ],
});
